import React from 'react';
import { ArrowRightIcon, AtSignIcon, MailIcon, TrophyIcon } from 'lucide-react';
import { CTAButton, INSTAGRAM_HANDLE, INSTAGRAM_LINK, PRICE, PRODUCT_SPEC, SUPPORT_EMAIL, Section } from './Shared';
import { Blossom, Daisy, FlowerSpike, Sprig } from './FloralDecor';
export function ClosingCTA() {
  return <Section className="max-w-4xl" data-id="element-31" data-mp="2n6kgkggn2kyh">
      <div className="relative overflow-hidden rounded-xl border border-emerald-200 bg-emerald-50 px-6 py-10 text-center md:px-12 md:py-14" data-id="element-32" data-mp="2n7m43keuczx3">
        <Blossom className="pointer-events-none absolute -left-6 -top-6 h-32 w-32" petalClassName="text-pink-300/60" centerClassName="text-amber-300" data-id="element-33" data-mp="3fvrno3u5sivc" />
        <Sprig className="pointer-events-none absolute -bottom-8 -right-4 h-48 w-28 text-emerald-600/25" data-id="element-34" data-mp="316lqelevt2q3" />
        <Daisy className="pointer-events-none absolute right-[8%] top-6 hidden h-14 w-14 md:block" petalClassName="text-white" centerClassName="text-amber-400" data-id="element-35" data-mp="364eyxl3nq8tj" />
        <FlowerSpike className="pointer-events-none absolute -bottom-4 left-[6%] hidden h-36 w-10 md:block" petalClassName="text-fuchsia-300/60" centerClassName="text-emerald-400/50" data-id="element-36" data-mp="2henxwcmc9pm" />
        <div className="relative" data-id="element-37" data-mp="r57h3q6bnub2">
          <p className="text-xs font-semibold tracking-widest text-rose-700 md:text-sm" data-id="element-38" data-mp="r68uw2eq2uwh">
            LA TUA PROSSIMA CONSULENZA COMINCIA CON UN CRITERIO
          </p>
          <h2 className="mt-3 text-3xl font-bold leading-tight tracking-tight text-emerald-900 md:text-4xl" data-id="element-39" data-mp="112bylcp831lj">
            La prossima consulenza può essere diversa.
          </h2>
          <div className="mx-auto mt-5 max-w-2xl space-y-4 text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-40" data-mp="19v70pxje8h73">
            <p data-id="element-41" data-mp="1oszfuol133kr">
              Puoi continuare a cercare tra appunti, ricostruire ogni volta il percorso e affidarti soltanto alla
              memoria.
            </p>
            <p data-id="element-42" data-mp="1jrij959ku39z">
              Oppure puoi avere una biblioteca organizzata: un manuale per guidare l’incontro, esempi per confrontare i
              fiori e schede per mantenere continuità.
            </p>
            <p className="font-medium text-stone-900" data-id="element-43" data-mp="f3hac29t96di">
              Non serve sapere tutto a memoria per lavorare con maggiore ordine. Serve avere strumenti utili nel
              momento in cui ti occorrono.
            </p>
            <p className="font-semibold text-emerald-800" data-id="element-44" data-mp="o3w9a4fp6jzh">Il tuo kit completo è disponibile a 20 €.</p>
          </div>

          <div className="mx-auto mt-8 max-w-lg rounded-xl border-2 border-amber-500 bg-white p-6 shadow-md" data-id="element-45" data-mp="t41t4yfq7270">
            <p className="flex items-center justify-center gap-2 text-sm font-bold tracking-wide text-emerald-900 md:text-base" data-id="element-46" data-mp="y1tvkmdzy6pg">
              <TrophyIcon className="h-5 w-5 text-amber-600" aria-hidden="true" data-id="element-47" data-mp="121khocskvynn" />
              KIT COMPLETO FIORI DI BACH™
            </p>
            <p className="mt-2 text-5xl font-bold tracking-tight text-emerald-700" data-id="element-48" data-mp="1btzzna3vkn8j">{PRICE}</p>
            <p className="mt-2 text-sm font-medium text-stone-700" data-id="element-49" data-mp="1gtcv2j8tb2mq">{PRODUCT_SPEC}</p>
            <p className="mt-1 text-sm text-stone-500" data-id="element-50" data-mp="1lro6gyer9l72">
              188 pagine di guide, esempi e strumenti visivi per organizzare la tua consulenza floreale.
            </p>
            <CTAButton variant="gold" fullWidth className="mt-6 gap-2 px-6 text-base md:text-lg" data-id="element-51" data-mp="367lzhqkc9ukm">
              VOGLIO IL KIT COMPLETO A 20 €
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-52" data-mp="2wazhd9jedhma" />
            </CTAButton>
            <p className="mt-4 text-xs text-stone-500 md:text-sm" data-id="element-53" data-mp="2rdr7dw8ekjw4">
              PDF digitali · Italiano · Consultabili su tablet · Stampabili
            </p>
          </div>
        </div>
      </div>

      <aside aria-labelledby="ps-title" className="mx-auto mt-10 max-w-2xl text-center" data-id="element-54" data-mp="3k2eln7uqi906">
        <h3 id="ps-title" className="text-lg font-bold text-emerald-900 md:text-xl" data-id="element-55" data-mp="3f9v8ud3vfhwf">
          P.S. Hai ancora una domanda?
        </h3>
        <p className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-56" data-mp="3ab0p98y2xpb9">
          Scrivici a{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-medium text-rose-700 transition-colors duration-150 ease-out hover:text-rose-800" data-id="element-57" data-mp="bn4mo8m55jwm">
            {SUPPORT_EMAIL}
          </a>{' '}
          oppure contattaci su Instagram:{' '}
          <a href={INSTAGRAM_LINK} target="_blank" rel="noreferrer" className="font-medium text-rose-700 transition-colors duration-150 ease-out hover:text-rose-800" data-id="element-58" data-mp="3shay21ro456s">
            {INSTAGRAM_HANDLE}
          </a>
          .
        </p>
        <p className="mt-2 text-base leading-relaxed text-stone-700" data-id="element-59" data-mp="3ik695u6ftvma">
          Ti aiutiamo a capire che cosa comprende il kit e come accedere ai materiali.
        </p>
        <p className="mt-5 text-base font-semibold text-emerald-800 md:text-lg" data-id="element-60" data-mp="f24w96m45up9">
          Dai una struttura alle tue conoscenze. Tieni il tuo kit accanto al prossimo incontro.
        </p>
        <ul className="mt-5 flex flex-col items-center justify-center gap-2 text-sm text-stone-700 sm:flex-row sm:gap-6" data-id="element-61" data-mp="5clbtwir5ssa">
          <li className="flex items-center gap-1.5" data-id="element-62" data-mp="t1npyue6h3i1">
            <MailIcon className="h-4 w-4 text-rose-600" aria-hidden="true" data-id="element-63" data-mp="t02un2k1hgj4" />
            {SUPPORT_EMAIL}
          </li>
          <li className="flex items-center gap-1.5" data-id="element-64" data-mp="2ijb7o4zwpp25">
            <AtSignIcon className="h-4 w-4 text-rose-600" aria-hidden="true" data-id="element-65" data-mp="2ii01jyizo57v" />
            {INSTAGRAM_HANDLE.replace('@', '')}
          </li>
        </ul>
      </aside>
    </Section>;
}